/* WonderCases — Universal Play/Pause toggle (HTML5 + YouTube + Vimeo)
   - Delegated click; works with dynamically loaded sections
   - Finds the nearest visible media to the clicked button
   - Syncs the icon via .is-paused on the button:
       .is-paused  => show PLAY icon
       (no class)  => show PAUSE icon
   - Listens to 'wc:auto-state' so autoplay változásakor is helyes lesz az ikon
   - Manual lock: button click beállítja container.dataset.wcUserPaused / mediaEl.dataset.wcUserPaused értéket
*/
(function(){
  const SEL_BTN = 'button.video-pause, .video-pause, [data-role="video-toggle"], .slideshow__pause, .slideshow__play, .js-video-toggle';
  const CONTAINER_SEL = '.video-hero, .video-hero__media-container, .video-hero__video-wrapper, .slideshow__slide, .slideshow__media, section, [data-section-id]';

  const isVisible = el =>
    !!el &&
    el.getBoundingClientRect().width > 0 &&
    el.getBoundingClientRect().height > 0 &&
    getComputedStyle(el).visibility !== 'hidden';

  function addOrUpdateQueryParam(url, key, val){
    try{ const u = new URL(url, location.href); u.searchParams.set(key,val); return u.toString(); }
    catch(_){ const hasQ = url.indexOf('?') !== -1;
      const re = new RegExp('([?&])'+key+'=[^&]*');
      if (re.test(url)) return url.replace(re, '$1'+key+'='+encodeURIComponent(val));
      return url + (hasQ?'&':'?') + key + '=' + encodeURIComponent(val);
    }
  }

  function detectIframeType(iframe){
    const src = (iframe.getAttribute('src') || '').toLowerCase();
    if (src.includes('youtube.com') || src.includes('youtu.be')) return 'youtube';
    if (src.includes('vimeo.com')) return 'vimeo';
    return 'unknown';
  }

  function closestContainer(fromEl){
    return (fromEl && fromEl.closest(CONTAINER_SEL)) || document.body;
  }

  function detectMedia(btn){
    const prev = btn.previousElementSibling;
    if (prev && prev.tagName === 'VIDEO') return { type:'html5', el: prev };
    if (prev && prev.tagName === 'IFRAME') return { type: detectIframeType(prev), el: prev };

    const next = btn.nextElementSibling;
    if (next && next.tagName === 'VIDEO') return { type:'html5', el: next };
    if (next && next.tagName === 'IFRAME') return { type: detectIframeType(next), el: next };

    const root = closestContainer(btn) || document;
    let v = Array.from(root.querySelectorAll('video')).find(isVisible);
    if (v) return { type:'html5', el: v };
    let f = Array.from(root.querySelectorAll('iframe')).find(isVisible);
    if (f) return { type: detectIframeType(f), el: f };

    v = Array.from(document.querySelectorAll('video')).find(isVisible);
    if (v) return { type:'html5', el: v };
    f = Array.from(document.querySelectorAll('iframe')).find(isVisible);
    if (f) return { type: detectIframeType(f), el: f };

    return null;
  }

  function ytEnsureJsApi(iframe){
    const src = iframe.getAttribute('src') || '';
    if (!/enablejsapi=1/.test(src)){
      iframe.setAttribute('src', addOrUpdateQueryParam(src, 'enablejsapi', '1'));
    }
  }
  function ytCmd(iframe, func){ iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({event:'command', func, args:[]}), '*'); }
  function vimeoCmd(iframe, method){ iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({method}), '*'); }

  function play(media){
    if (!media) return;
    if (media.type === 'html5'){
      const v = media.el;
      v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline','');
      if (v.muted !== true) v.muted = true;
      const p = v.play(); if (p && p.catch) p.catch(()=>{});
    } else if (media.type === 'youtube'){
      ytEnsureJsApi(media.el); ytCmd(media.el, 'playVideo');
    } else if (media.type === 'vimeo'){
      vimeoCmd(media.el, 'play');
    }
  }
  function pause(media){
    if (!media) return;
    if (media.type === 'html5'){ media.el.pause(); }
    else if (media.type === 'youtube'){ ytCmd(media.el, 'pauseVideo'); }
    else if (media.type === 'vimeo'){ vimeoCmd(media.el, 'pause'); }
  }

  function syncBtn(btn, paused){
    // paused -> show PLAY icon (add .is-paused)
    btn.classList.toggle('is-paused', !!paused);
    btn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
  }

  function initialSync(ctx){
    (ctx || document).querySelectorAll(SEL_BTN).forEach(btn=>{
      const media = detectMedia(btn);
      const container = closestContainer(btn);
      if (media?.type === 'html5'){
        // true state from the video element
        syncBtn(btn, media.el.paused);
        if (!media.el.__wcBound){
          media.el.addEventListener('play',  ()=>syncBtn(btn,false));
          media.el.addEventListener('pause', ()=>syncBtn(btn,true));
          media.el.__wcBound = true;
        }
      } else if (media){
        // default assume paused until we get auto-state events
        syncBtn(btn, true);
      }
      // seed lock flags
      if (container && !container.dataset.wcUserPaused) container.dataset.wcUserPaused = media?.type==='html5' ? (media.el.paused?'1':'0') : '1';
      if (media?.el && !media.el.dataset.wcUserPaused) media.el.dataset.wcUserPaused = media?.type==='html5' ? (media.el.paused?'1':'0') : '1';
    });
  }

  // Delegated click (capture phase helps if overlays exist)
  document.addEventListener('click', function(e){
    const btn = e.target.closest && e.target.closest(SEL_BTN);
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const media = detectMedia(btn);
    const container = closestContainer(btn);
    if (!media) return;

    // toggle play/pause + manual lock + icon
    if (media.type === 'html5'){
      if (media.el.paused){ play(media);  syncBtn(btn,false); if (container) container.dataset.wcUserPaused='0'; media.el.dataset.wcUserPaused='0'; }
      else { pause(media); syncBtn(btn,true);  if (container) container.dataset.wcUserPaused='1'; media.el.dataset.wcUserPaused='1'; }
    } else if (media.type === 'youtube' || media.type === 'vimeo'){
      const paused = btn.classList.contains('is-paused');
      if (paused){ play(media);  syncBtn(btn,false); if (container) container.dataset.wcUserPaused='0'; media.el.dataset.wcUserPaused='0'; }
      else       { pause(media); syncBtn(btn,true);  if (container) container.dataset.wcUserPaused='1'; media.el.dataset.wcUserPaused='1'; }
    }
    // notify autoplay logic that user explicitly played (optional)
    document.dispatchEvent(new CustomEvent('wc:user-play', { bubbles:true, detail:{ container, mediaEl: media.el }}));
  }, true);

  // Listen to autoplay engine and reflect icon state
  document.addEventListener('wc:auto-state', (ev)=>{
    const el = ev.detail && ev.detail.el;
    const playing = !!(ev.detail && ev.detail.playing);
    if (!el) return;
    const container = closestContainer(el);
    // find a toggle button near this media
    const btn = container && container.querySelector(SEL_BTN);
    if (btn) syncBtn(btn, !playing);
  });

  document.addEventListener('DOMContentLoaded', ()=>initialSync(document));
  document.addEventListener('shopify:section:load',  e=>initialSync(e.target));
  document.addEventListener('shopify:section:select',e=>initialSync(e.target));
})();
